var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PortalCard',{attrs:{"content":_vm.content,"characters":_vm.characters},on:{"clickCard":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }